import React from 'react';
import PropTypes from 'prop-types';

import { useUseCases } from '../../hooks/use-use-cases';

import { List } from '../common/list';

import styles from './use-cases.module.scss';

export const UseCases = ({ data, linkGenerator }) => {
	const { items: useCases } = useUseCases();

	return (
		<div className={styles.wrapper}>
			<div className={styles.container}>
				<h2>{data.header}</h2>
				<List items={useCases} linkGenerator={linkGenerator} />
			</div>
		</div>
	);
};

UseCases.defaultProps = {
	data: {},
	linkGenerator: () => {},
};

UseCases.propTypes = {
	data: PropTypes.object.isRequired,
	linkGenerator: PropTypes.func.isRequired,
};
